//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "VocSwitch",
  props: {
    value: {
      type: [Boolean, String, Number],
      default: true
    },
    activeValue: {
      type: [Boolean, String, Number],
      default: true
    },
    inactiveValue: {
      type: [Boolean, String, Number],
      default: false
    }
  },
  data() {
    return {
      innerValue: undefined
    }
  },
  watch: {
    value: {
      handler(v) {
        this.innerValue = v
      },
      immediate: true
    }
  },
  methods: {
    onValueChanged(v) {
      this.innerValue = v
      // 触发事件
      // 这一个事件允许使用 sync 修饰符
      this.$emit("update:value", v)
      // 允许用户自定义事件处理
      this.$emit("voc-switch-value-changed", v)
    }
  }
}
